export interface KochiLocation {
  name: string;
  description: string;
  href: string;
}

export const KOCHI_LOCATIONS: KochiLocation[] = [
  {
    name: 'Kakkanad',
    description: 'InfoPark, SmartCity & Civil Station',
    href: '/cleaning-service-kakkanad',
  },
  {
    name: 'Edappally',
    description: 'Metro Corridor & NH Bypass',
    href: '/cleaning-service-edappally',
  },
  {
    name: 'Kaloor',
    description: 'JLN Stadium & Deshabhimani',
    href: '/cleaning-service-kaloor',
  },
  {
    name: 'Kalamassery',
    description: 'CUSAT, HMT Colony & Pathadipalam',
    href: '/cleaning-service-kalamassery',
  },
  {
    name: 'M.G. Road',
    description: 'Menaka, Jos Junction & Marine Drive',
    href: '/cleaning-service-mg-road',
  },
  {
    name: 'Panampilly Nagar',
    description: 'Boutique homes & cafes',
    href: '/cleaning-service-panampilly-nagar',
  },
  {
    name: 'Kadavanthra',
    description: 'SA Road, GCDA & Jawahar Nagar',
    href: '/cleaning-service-kadavanthra',
  },
  {
    name: 'Vyttila',
    description: 'Mobility Hub & NH Bypass',
    href: '/cleaning-service-vyttila',
  },
  {
    name: 'Palarivattom',
    description: 'Pipeline Road & Signal Junction',
    href: '/cleaning-service-palarivattom',
  },
  {
    name: 'Aluva',
    description: 'Metro Terminal & Airport Corridor',
    href: '/cleaning-service-aluva',
  },
  {
    name: 'Willingdon Island',
    description: 'Port, Naval Base & Hotels',
    href: '/cleaning-service-willingdon-island',
  },
  {
    name: 'Eloor',
    description: 'Udyogamandal & Riverfront Townships',
    href: '/cleaning-service-eloor',
  },
  {
    name: 'Marine Drive',
    description: 'Waterfront towers & Shanmugham Road',
    href: '/cleaning-service-marine-drive',
  },
  {
    name: 'Fort Kochi',
    description: 'Heritage stays & Mattancherry',
    href: '/cleaning-service-fort-kochi',
  },
  {
    name: 'Broadway',
    description: 'Ernakulam Bazaar & Market Road',
    href: '/cleaning-service-broadway',
  },
  {
    name: 'Thripunithura',
    description: 'Hill Palace & Gandhinagar',
    href: '/cleaning-service-thripunithura',
  },
  {
    name: 'Thrikkakara',
    description: 'CUSAT & Infopark Corridor',
    href: '/cleaning-service-thrikkakara',
  },
  {
    name: 'Maradu',
    description: 'NH Bypass & Lake Road',
    href: '/cleaning-service-maradu',
  },
  {
    name: 'North Paravur',
    description: 'Coastal Ernakulam (Paravur)',
    href: '/cleaning-service-north-paravur',
  },
  {
    name: 'Kumbalangi',
    description: 'Backwater Village & Homestays',
    href: '/cleaning-service-kumbalangi',
  },
  {
    name: 'Angamaly',
    description: 'Airport Highway & NH 544',
    href: '/cleaning-service-angamaly',
  },
  {
    name: 'Perumbavoor',
    description: 'Eastern Ernakulam',
    href: '/cleaning-service-perumbavoor',
  },
  {
    name: 'Muvattupuzha',
    description: 'Central Kerala Town',
    href: '/cleaning-service-muvattupuzha',
  },
  {
    name: 'Vennala',
    description: 'Bypass & School Road',
    href: '/cleaning-service-vennala',
  },
  {
    name: 'Elamkulam',
    description: 'Metro & SA Road',
    href: '/cleaning-service-elamkulam',
  },
  {
    name: 'Thevara',
    description: 'Waterfront & Junction',
    href: '/cleaning-service-thevara',
  },
  {
    name: 'Palluruthy',
    description: 'West Kochi',
    href: '/cleaning-service-palluruthy',
  },
  {
    name: 'Vazhakkala',
    description: 'Infopark corridor',
    href: '/cleaning-service-vazhakkala',
  },
  {
    name: 'Thammanam',
    description: 'Kaloor–Palarivattom belt',
    href: '/cleaning-service-thammanam',
  },
  {
    name: 'Elamakkara',
    description: 'Ponekkara & Edappally',
    href: '/cleaning-service-elamakkara',
  },
  {
    name: 'Cheranalloor',
    description: 'North Kochi river belt',
    href: '/cleaning-service-cheranalloor',
  },
  {
    name: 'Nettoor',
    description: 'Kundanoor high-rises',
    href: '/cleaning-service-nettoor',
  },
  {
    name: 'Irumpanam',
    description: 'SPA Road corridor',
    href: '/cleaning-service-irumpanam',
  },
  { name: 'Thoppumpady', description: 'West Kochi gateway', href: '/cleaning-service-thoppumpady' },
  { name: 'Mattancherry', description: 'Jew Town & Palace', href: '/cleaning-service-mattancherry' },
  { name: 'Vypin', description: 'Vypeen island homes', href: '/cleaning-service-vypin' },
  { name: 'Ponnurunni', description: 'Petta & Vyttila west', href: '/cleaning-service-ponnurunni' },
  { name: 'Kundanoor', description: 'Bypass high-rises', href: '/cleaning-service-kundanoor' },
  { name: 'Pachalam', description: 'North town streets', href: '/cleaning-service-pachalam' },
  { name: 'Vaduthala', description: 'Chittoor river belt', href: '/cleaning-service-vaduthala' },
  { name: 'Mamangalam', description: 'Palarivattom–Vennala', href: '/cleaning-service-mamangalam' },
  { name: 'Ponekkara', description: 'Metro & Lulu side', href: '/cleaning-service-ponekkara' },
  {
    name: 'Ernakulam South',
    description: 'Junction & Pallimukku',
    href: '/cleaning-service-ernakulam-south',
  },
  { name: 'Ravipuram', description: 'Hospital Road flats', href: '/cleaning-service-ravipuram' },
  { name: 'Padamugal', description: 'Infopark-side towers', href: '/cleaning-service-padamugal' },
  { name: 'Kumbalam', description: 'Backwater villas', href: '/cleaning-service-kumbalam' },
  { name: 'Nedumbassery', description: 'CIAL airport corridor', href: '/cleaning-service-nedumbassery' },
  { name: 'Athani', description: 'Airport highway', href: '/cleaning-service-athani' },
  { name: 'Kalady', description: 'River-town homes', href: '/cleaning-service-kalady' },
  { name: 'Malayattoor', description: 'Pilgrim-town homes', href: '/cleaning-service-malayattoor' },
  { name: 'Kolenchery', description: 'MOSC & town', href: '/cleaning-service-kolenchery' },
  { name: 'Kothamangalam', description: 'Eastern town homes', href: '/cleaning-service-kothamangalam' },
  { name: 'Chottanikkara', description: 'Temple-town homes', href: '/cleaning-service-chottanikkara' },
  { name: 'Aroor', description: 'NH 66 industrial belt', href: '/cleaning-service-aroor' },
  { name: 'Varapuzha', description: 'Bridge & river homes', href: '/cleaning-service-varapuzha' },
  { name: 'Piravom', description: 'River-town dispatch', href: '/cleaning-service-piravom' },
  { name: 'Kizhakambalam', description: 'Infopark east', href: '/cleaning-service-kizhakambalam' },
  { name: 'Puthencruz', description: 'SPA Road east', href: '/cleaning-service-puthencruz' },
  { name: 'Udayamperoor', description: 'Lake-side villas', href: '/cleaning-service-udayamperoor' },
  { name: 'Mulanthuruthy', description: 'Piravom Road homes', href: '/cleaning-service-mulanthuruthy' },
  { name: 'Kodungallur', description: 'Coastal temple town', href: '/cleaning-service-kodungallur' },
  { name: 'Cherai', description: 'Beach & homestays', href: '/cleaning-service-cherai' },
  { name: 'Vaikom', description: 'Lake-town homes', href: '/cleaning-service-vaikom' },
  { name: 'Thiruvankulam', description: 'Hill Palace east', href: '/cleaning-service-thiruvankulam' },
  { name: 'Chellanam', description: 'Coastal West Kochi', href: '/cleaning-service-chellanam' },
  { name: 'Choornikkara', description: 'Aluva–Kalamassery belt', href: '/cleaning-service-choornikkara' },
  { name: 'Cherthala', description: 'NH 66 & backwater town', href: '/cleaning-service-cherthala' },
  { name: 'Thuravoor', description: 'Temple town on NH 66', href: '/cleaning-service-thuravoor' },
  { name: 'Mararikulam', description: 'Marari beach homes', href: '/cleaning-service-mararikulam' },
  { name: 'Chalakudy', description: 'Kochi–Thrissur highway', href: '/cleaning-service-chalakudy' },
  { name: 'Mala', description: 'Mala town homes', href: '/cleaning-service-mala' },
  { name: 'Irinjalakuda', description: 'Thrissur-south town', href: '/cleaning-service-irinjalakuda' },
  { name: 'Kodakara', description: 'NH 544 Kodakara', href: '/cleaning-service-kodakara' },
  { name: 'Koratty', description: 'Airport-highway town', href: '/cleaning-service-koratty' },
  { name: 'Karukutty', description: 'Angamaly-north town', href: '/cleaning-service-karukutty' },
  { name: 'Chengamanad', description: 'Airport-road homes', href: '/cleaning-service-chengamanad' },
  { name: 'Njarakkal', description: 'Vypin island town', href: '/cleaning-service-njarakkal' },
  { name: 'Nayarambalam', description: 'Vypin backwater homes', href: '/cleaning-service-nayarambalam' },
  { name: 'Eramalloor', description: 'NH 66 Eramalloor', href: '/cleaning-service-eramalloor' },
  { name: 'Arookutty', description: 'Backwater island homes', href: '/cleaning-service-arookutty' },
  { name: 'Alangad', description: 'Aluva–Varapuzha belt', href: '/cleaning-service-alangad' },
  { name: 'Koonammavu', description: 'North Kochi river town', href: '/cleaning-service-koonammavu' },
  { name: 'Kodanad', description: 'Periyar riverside', href: '/cleaning-service-kodanad' },
  { name: 'Annamanada', description: 'Mala–Chalakudy town', href: '/cleaning-service-annamanada' },
  {
    name: 'Kottayam',
    description: 'Nearby city – Central Kerala',
    href: '/cleaning-service-kottayam',
  },
  {
    name: 'Alappuzha',
    description: 'Nearby city – Backwaters',
    href: '/cleaning-service-alappuzha',
  },
  {
    name: 'Thrissur',
    description: 'Nearby city – Cultural capital',
    href: '/cleaning-service-thrissur',
  },
];
